import sanitizeHtml from 'sanitize-html'

/* eslint-disable */
sanitizeHtml.defaults.allowedAttributes['*'] = [ 'class', 'style' ]
sanitizeHtml.defaults.allowedAttributes['a'] = [ 'href', 'name', 'target' ]
sanitizeHtml.defaults.allowedTags = [ 'a', 'b', 'i', 'em', 'strong', 'br', 'sup','ul','li','ol' ]
/* eslint-enable */

export default sanitizeHtml.defaults
